const icon = require('vue-svgicon');
icon.register({
    'facebook': {
        width: 48,
        height: 48,
        viewBox: '0 0 48 48',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M38 24c0-7.732-6.268-14-14-14s-14 6.268-14 14c0 6.988 5.12 12.78 11.813 13.83v-9.783h-3.555V24h3.555v-3.084c0-3.51 2.09-5.447 5.288-5.447 1.531 0 3.133.273 3.133.273v3.445H28.47c-1.74 0-2.282 1.08-2.282 2.187V24h3.883l-.62 4.047h-3.262v9.783C32.88 36.78 38 30.988 38 24z" _fill="#000"/>`,
    },
});
